export default [
  {
    path: '/provinces',
    name: 'provinces',
    component: () => import('@views/wxQr/provinces.vue'),
    meta: {
      title: '选择你要加入的地区群'
    }
  },
  {
    path: '/qr',
    name: 'qr',
    component: () => import('@views/wxQr/qr.vue'),
    meta: {
      title: '邀工网招工找活群'
    }
  }
  ,
  {
    path: '/custom',
    name: 'custom',
    component: () => import('@views/wxQr/custom.vue'),
    meta: {
      title: '邀工网客服群'
    }
  }

]
